import instance from '@/services/repository';
import settings from '@/settings.json';
import { SecurityConfig } from "@/installationConfig";

const resource = '/employees';

export default {
    get() {
        return instance.get(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get(`${resource}/${id}`);
    },
    getRoles(id: string) {
        return instance.get<IEmployeeRoles>(`${resource}/${id}/Roles`);
    },
    updateRoles(id: string, roles: IEmployeeRoles) {
        return instance.post(`${resource}/${id}/Roles`, roles);
    },
    getTeams() {
        const teams = [
            { value: SecurityConfig.administratorGroup, text: 'Admin' },
            { value: SecurityConfig.administrationGroup, text: 'Administratie' },
            { value: SecurityConfig.calculatorGroup, text: 'Calculators' },
            { value: SecurityConfig.hrGroup, text: 'Human Resources' },
            { value: SecurityConfig.projectCoordinatorGroup, text: 'Project Coördinator' },
            { value: SecurityConfig.qualityGuardGroup, text: 'Quality Guards' },
            { value: SecurityConfig.qualityGuardOneSkinGroup, text: 'Quality Guards (OneSkin)'}
        ];
        return teams;
    },
    getTeam(value: string) {
        const teams = this.getTeams();

        return teams.find((o: any) => o.value === value);
    },
};
